import { Link } from '@tanstack/react-router';

import { RECOMMENDATION_ROUTE } from '@/constants/routes';
import { useTranslation } from '@/utils/i18n';
import { MusicNoteIcon } from '@/components/icons/TabIcons';
import { cn } from '@/lib/utils';
import { isRecoFlow } from './tabs';

interface Props {
  pathname: string;
  /** Raised above the docked bar (Android, web); centred in the iOS capsule (QA PO 2026-10-30). */
  raised?: boolean;
  /** 48 px with a 24 px note — Android's 48 dp target (android-tab-bar); iOS keeps 44 pt. */
  large?: boolean;
}

/** Center FAB → recommendation flow; yellow while that flow is active. */
export default function RecoFab({ pathname, raised = true, large = false }: Props) {
  const { t } = useTranslation();
  const recoActive = isRecoFlow(pathname);

  return (
    <div className="tw:flex tw:w-14 tw:shrink-0 tw:items-center tw:justify-center">
      <Link
        to={RECOMMENDATION_ROUTE}
        data-testid="tab-recommendation-fab"
        aria-label={t('tabs.discover')}
        className={cn(
          'tw:flex tw:items-center tw:justify-center tw:rounded-full tw:shadow-lg',
          large ? 'tw:size-12' : 'tw:size-11',
          raised && 'tw:-mt-2',
        )}
        style={{
          background: recoActive
            ? 'linear-gradient(180deg, var(--tw-color-yellow-primary) 0%, var(--tw-color-yellow-5) 100%)'
            : 'linear-gradient(180deg, var(--tw-color-blue-primary) 0%, var(--tw-color-blue-6) 100%)',
          // NB: this was pure white; the system's white is slightly softer,
          // and is what every other surface already uses.
          color: recoActive ? 'var(--tw-color-dark-primary)' : 'var(--tw-color-white)',
        }}
      >
        <MusicNoteIcon size={large ? 24 : 22} />
      </Link>
    </div>
  );
}
